import { render, staticRenderFns } from "./StoryShareForm.vue?vue&type=template&id=5e7c3c18"
import script from "./StoryShareForm.vue?vue&type=script&lang=js"
export * from "./StoryShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports